import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=6525970c&"
import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports